let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Kwo5")).then(() => parcelRequire('en88g'));